import Vue from 'vue';
import i18n from '@/libs/i18n';
import router from '@/router';
import ChatToastification from '@/components/ChatToastification.vue';

export default {
  subscribe: (state, data) => {
    state.subscribe = data;
  },
  roomsSubscribe: (state, data) => {
    state.roomsSubscribe = data;
  },
  setRoomIds: (state, data) => {
    state.roomIds = data;
  },
  setRooms: (state, data) => {
    state.rooms = [...data];
  },
  appendRooms: (state, data) => {
    const roomIds = new Set(state.rooms.map((room) => room.roomId));
    const rooms = [...state.rooms];
    data.forEach((room) => {
      if (!roomIds.has(room.roomId)) {
        rooms.push(room);
      }
    });
    state.rooms = rooms.sort((a, b) => b.index - a.index);
  },
  setRoomsCursor: (state, data) => {
    state.roomsCursor = data;
  },
  setRoomsPageLoaded: (state, data) => {
    state.roomsPageLoaded = data;
  },
  resetRoomsPagination: (state) => {
    state.roomsCursor = null;
    state.roomsPageLoaded = false;
  },
  clearRoomMessages: (state) => {
    state.roomMessages = [];
  },

  setRoomMessages: (state, data) => {

    const liveMessageIds = new Set(data.map((message) => message._id));
    const olderMessages = state.roomMessages.filter((message) => !liveMessageIds.has(message._id));
    state.roomMessages = [...olderMessages, ...data];

    // data.map((message) => {
    //     if (state.roomMessages.every((_msg) => _msg._id != message._id)) {
    //         state.roomMessages.push(message)
    //     }
    //
    // })
  },
  pushRoomMessages: (state, data) => {

    if (state.roomMessages.every((message) => message._id !== data._id))
      state.roomMessages.push(data);

  },
  prependRoomMessages: (state, data) => {
    const messageIds = new Set(state.roomMessages.map((message) => message._id));
    state.roomMessages = [
      ...data.filter((message) => !messageIds.has(message._id)),
      ...state.roomMessages
    ];
  },
  setRoomMessagesCursor: (state, data) => {
    state.roomMessagesCursor = data;
  },
  setRoomMessagesPageLoaded: (state, data) => {
    state.roomMessagesPageLoaded = data;
  },
  resetRoomMessagesPagination: (state, roomId) => {
    state.currentMessagesRoomId = roomId;
    state.roomMessagesCursor = null;
    state.roomMessagesPageLoaded = false;
  },
  setNewRoom: (state, data) => {
    //show notification
    try{

    var date = data[0]['index'];// ex:Mon Jun 03 2024 11:13:43 GMT+0300 (Arabian Standard Time)
    // if the date is more than 5 minutes ago then don't show the notification
    var now = new Date();
    var diff = now - date;
    var diffMinutes = Math.floor(diff / 60000);
    if (diffMinutes > 5) {
      return;
    }
    }catch(e){
      return;
    }


    for (const room of data) {
      Vue.$toast(
        {
          component: ChatToastification,
          props: {
            orderId: room.roomId,
            title: room.roomName,
            btn: i18n.t('common.show_details'),
            label: i18n.t('common.new_chat'),
            body: room.lastMessage.content
          },
          listeners: {
            goToDetail: () => {
              if (router.currentRoute.name !== 'chat') {
                router.push({
                  name: 'chat',
                  params: { lang: i18n.locale },
                  meta: {
                    room: room.roomId
                  }
                });
                state.activeRoom = room;
              } else {
                //update room meta
                state.activeRoom = room;
              }
            }  // Optional
          }
        },
        {
          toastClassName: 'new-chat-notification',
          position: 'bottom-right',
          timeout: 3000

        }
      );
    }

  },
  setActiveRoom: (state, data) => {
    state.activeRoom = data;
  },
  setRoomsForFirstTime: (state, data) => {
    state.roomsForFirstTime = data;
  },
  resetChatListeners: (state) => {
    state.subscribe = null;
    state.roomsSubscribe = null;
  },
  resetChatData: (state) => {
    state.subscribe = null;
    state.roomsSubscribe = null;
    state.roomsCursor = null;
    state.roomsPageLoaded = true;
    state.currentMessagesRoomId = null;
    state.roomMessagesCursor = null;
    state.roomMessagesPageLoaded = true;
    state.roomIds = [];
    state.rooms = [];
    state.roomMessages = [];
    state.activeRoom = null;
  }
};
